"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prependBaseUrl = prependBaseUrl;
const url_join_1 = __importDefault(require("url-join"));
function isAbsolute(url) {
    return /^https?:\/\//.test(url);
}
/**
 * Prepends the given `base` - which can be relative or absolute - to the `url`,
 * unless the `url` is absolute.
 */
function prependBaseUrl(base, url) {
    if (!base || isAbsolute(url)) {
        return url;
    }
    return (0, url_join_1.default)(base, url);
}
//# sourceMappingURL=prepend-base-url.js.map